import * as React from 'react';
import { FieldsMappingContext } from '../Context';
import { useProfileTeaserFields } from './hooks';
import Links, { Link } from './profile-teaser/Links';

function SpecializationField({value}) {
  if (Array.isArray(value) && value.length > 0) {
    return value.join(',');
  }
  if (value) {
    return value;
  }
  return '';
}

export default function (props) {
  const { hit } = props;
  const { profileTeaser } = React.useContext(FieldsMappingContext);
  const [mapping] = profileTeaser;

  const {
    image,
    links,
    title = null,
    jobRole,
    specialization = [],
    institutionName,
    pageUrl,
  } = useProfileTeaserFields(hit, mapping);

  return (
    <div className='profile-teaser'>
      <div className='profile-teaser__content'>
        <div className='profile-teaser__image'>
          <img src={image} alt={title} />
        </div>
        <div className='profile-teaser__links'>
          <Links links={links} />
        </div>
        <div className='profile-teaser__fields'>
          <div className='fields-groups'>
            <div className='fields-group'>
              <h3 className='h--smallest field field--title'>{title}</h3>
              <div className='field field--job-role'>{jobRole}</div>
            </div>
            <div className='fields-group'>
              <div className='field field--heading text-bold'>研究方向</div>
              <div className='field field--heading field--specialization'>
                <SpecializationField value={specialization}/>
              </div>
              <div className='field field--institution-name'>{institutionName}</div>
            </div>
          </div>
          {pageUrl?.trim() && <a href={pageUrl} className='nv-cta-secondary nv-cta-secondary--small'>{I18n.t('profile_teasers.profile_page')}</a>}
        </div>
      </div>
    </div>
  );
}
